import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { H as o } from "./chunks/index-UjijAVoZ.js";
import a from "./InteractiveSteps.js";
const n = () => /* @__PURE__ */ t("div", { className: "container-xl flex flex-col gap-8 items-center", children: [
  /* @__PURE__ */ t("div", { className: "flex flex-col gap-6 tablet:items-center tablet:text-center", children: [
    /* @__PURE__ */ e(
      o,
      {
        className: "leading-tight tablet:max-w-[30ch]",
        level: "1",
        tagName: "h2",
        children: "How to apply"
      }
    ),
    /* @__PURE__ */ e("p", { className: "max-w-prose text-lg", children: "Our Partner Program is open to applications only. This way, we can ensure our affiliates align with our mission and values. We’d love to hear from you if you’re excited to promote project-based learning to developers worldwide." })
  ] }),
  /* @__PURE__ */ t(a, { className: "w-full", children: [
    /* @__PURE__ */ e(
      a.Step,
      {
        heading: 'Click "Apply now"',
        image: "https://res.cloudinary.com/dz209s6jk/image/upload/v1739976205/DesignSystem/become-a-partner-2.webp",
        children: "You’ll be redirected to our application page."
      }
    ),
    /* @__PURE__ */ e(
      a.Step,
      {
        heading: "Share your details",
        image: "https://res.cloudinary.com/dz209s6jk/image/upload/v1739976205/DesignSystem/become-a-partner-3.webp",
        children: "Tell us about your audience, network, platforms, and how you plan to promote Frontend Mentor."
      }
    ),
    /* @__PURE__ */ e(
      a.Step,
      {
        heading: "Receive approval",
        image: "https://res.cloudinary.com/dz209s6jk/image/upload/v1739976204/DesignSystem/become-a-partner-4.webp",
        children: "Our team will review your application and get back to you promptly."
      }
    )
  ] })
] });
export {
  n as default
};
